<template>
  <div class="image_app">
    <div class="image_wrapper" ref="c_image">
      <div class="t_image">Demo</div>
      <img
        class="img"
        :src="url"
        :srcset="`${url} 1x, ${url2} 2x`"
        ref="o_image"
      />
    </div>
    <div class="limit" v-if="limit"><span>Image is larger than the available area - <a :href="url" target="_blank">open image <i class="fa fa-external-link-alt"></i></a></span></div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'url',
      'url2'
    ])
  },
  data () {
    return {
      limit: false
    }
  },
  watch: {
    url () {
      setTimeout(() => {
        let wC = this.$refs.c_image.clientWidth
        let hC = this.$refs.c_image.clientHeight
        let wI = this.$refs.o_image.clientWidth
        let hI = this.$refs.o_image.clientHeight
        wC <= wI || hC <= hI ? this.limit = true : this.limit = false
      }, 300)
    }
  }
}
</script>
<style lang="scss" scoped>
.image_app{
  position: relative;
  max-width: 100%;
  text-align: center;
  min-height: 150px;
  max-height: 150px;
  height: 150px;
  @media only screen and (min-width : 480px){
    min-height: 480px;
    max-height: 480px;
    height: 480px;
  }
}
.imgfile{
  opacity: 0;
}
.image_wrapper{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  min-height: 150px;
  max-height: 150px;
  height: 150px;
  @media only screen and (min-width : 480px){
    min-height: 480px;
    max-height: 480px;
    height: 480px;
  }
}
.t_image{
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 10px;
  font-weight: bold;
  font-size: 20px;
  background-color: #327BBA;
  color: #fff;
  border-radius: 4px;
}
.link_image {
  position: absolute;
  z-index: 999;
  cursor: pointer;
  right: 0;
  top: 0;
  padding: 5px 10px;
  font-weight: bold;
  font-size: 20px;
  background-color: #327BBA;
  color: #fff;
  svg{
    width: 14px;
  }
}
.limit{
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  width: 100%;
  background-color: #327BBA;
  min-height: 30px;
  color: #fff;
  a{
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    &:hover{
      opacity: .8
    }
  }
}
.img {
  display: block;
}

</style>
